const toPositiveInteger = value => {
  if (!['string', 'number'].includes(typeof value)) return null;
  const numeric = Number(value);
  return Number.isSafeInteger(numeric) && numeric > 0 ? numeric : null;
};

export const buildParticipantWorkspaceHref = item => {
  const caseId = toPositiveInteger(item?.case_id ?? item?.caseId);
  if (!caseId) return null;
  const rawApplicationId = item?.application_id ?? item?.applicationId;
  const href = `/cases/${encodeURIComponent(caseId)}`;
  // Imported cases and client-level batch results have no application scope.
  if (rawApplicationId == null || (typeof rawApplicationId === 'string' && rawApplicationId.trim() === '')) return href;
  const applicationId = toPositiveInteger(rawApplicationId);
  // Never silently replace a malformed application reference with the default one.
  return applicationId ? `${href}?applicationId=${encodeURIComponent(applicationId)}` : null;
};
